const _temp0 = require("./icons/edit_item.svg");
const _temp1 = require("./icons/open_chat.svg");
const _temp2 = require("./icons/trash.svg");
module.exports = {
  "edit_item": _temp0,
  "open_chat": _temp1,
  "trash": _temp2
}